export var valuesPostVisibleState = ["True", "False", "Ignore"];
/*

*/ 
//# sourceMappingURL=PostVisibleState.js.map